import { usePopup } from '@/compositions/popup';
import { schemasService } from '@/modules/common/api';
import { genMenuItemEdit, genMenuItemDelete } from '@/utils/list-generators';
import { genMenuItemDefault } from '@/utils/list-generators/menu';

export function useGeoItemMenu() {
  const popup = usePopup();

  return {
    genMenu: geoItem => {
      const { id, typeId } = geoItem;
      const items = [
        genMenuItemEdit(() => {
          popup.open({
            component: () =>
              import(
                '@/modules/object-types/ui/type-card/general/GeoItemEdit.vue'
              ),
            props: {
              geoItemId: id,
              parentSchemaId: typeId
            }
          });
        }),
        genMenuItemDefault(
          {
            id: 'alarms',
            icon: '$alert',
            title: 'Alarms'
          },
          {
            click: () => {
              popup.open({
                component: () => import('./GeoItemAlarmsDefaultEdit.vue'),
                props: {
                  geoItemId: id
                }
              });
            }
          }
        ),
        genMenuItemDelete(() => {
          popup.openConfirm({
            component: () =>
              import('@/components/popup/PopupConfirmAction.vue'),
            props: {
              title: 'Delete geo item?',
              onConfirm: () => schemasService.delete(id)
            }
          });
        })
      ];
      return items;
    }
  };
}
